import Blob from 'blob';

const labels = [
  {
    name: 'S.No',
    value: 'index',
  },
    
  {
    name: 'Name',
    value: 'companyName',
  },
  {
    name: 'Company Type',
    value: 'companyType',
  },
  {
    name: 'Registered Students',
    value: 'count',
  },
  {
    name: 'Date of Drive',
    value: 'date',
  },
  {
    name: 'Website',
    value: 'website',
  },
  {
    name: 'Company Description',
    value: 'companyDescription',
  },
  {
    name: 'Degrees',
    value: 'degrees',
  },
  {
    name: 'Last Registration Date',
    value: 'lastRegdDate',
  },
  {
    name: 'Location',
    value: 'location',
  },
  {
    name: 'Skills Required',
    value: 'skills',
  },
  {
    name: 'Streams',
    value: 'streams',
  },
  {
    name: 'Drive Process',
    value: 'tests',
  },
  {
    name: 'Job CTC',
    value: 'jobs',
  },
  {
    name: 'Job Details',
    // value: 'jobs',
  },
  {
    name: 'Job Locatrion',
    // value: 'jobs',
  },
  {
    name: 'Job Role',
    // value: 'jobs',
  },
  {
    name: 'Job Type',
    // value: 'jobs',
  },

];
  
const csvConverter = (JSONData, fileName = 'Registrations') => {
  const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
  let csv = '';
  let row = '';
    // let contactLen = 0;

  labels.forEach((fieldName) => {
    row += `${fieldName.name},`;
  });

  row = row.slice(0, -1);
  csv += `${row}\r\n`;
  
  for (let i = 0; i < arrData.length; i += 1) {
    row = '';
    const arrRow = arrData[i];
      // eslint-disable-next-line
      labels.forEach((fieldName) => {
        const { value } = fieldName;
        if (value === 'index') {
          row += `${i + 1},`;
        } else if (value === 'location') {
          const arrValue = typeof arrRow[value] === 'undefined' ? '' : `"${arrRow[value].description}"`;
          row += `${arrValue},`;
        } else if (value === 'date' || value === 'lastRegdDate') {
          const arrValue = typeof arrRow[value] === 'undefined' ? '' : `"${arrRow[value].date}/${arrRow[value].month}/${arrRow[value].year}"`;
          row += `${arrValue},`;
        } else if (value === 'skills') {
          const arr = [];
          if (arrRow[value] !== undefined) {
            for (let j = 0; j < arrRow[value].length; j += 1) {
              arr[j] = arrRow[value][j].skill;
            }
          }
          const skills = arr.join(' | ');
          row += `"${skills}",`;
        } else if (value === 'streams') {
          const arr = [];
          if (arrRow[value] !== undefined) {
            for (let j = 0; j < arrRow[value].length; j += 1) {
              arr[j] = arrRow[value][j].stream;
            }
          }
          const stream = arr.join(' | ');
          row += `${stream},`;
        } else if (value === 'jobs') {
          if (typeof arrRow[value] !== 'undefined') {
            arrRow[value].forEach((job) => {
              row += `"${job.jobCtc}", "${job.jobDescription}", "${job.jobLocation}", "${job.jobPosition}", "${job.jobType}",`;
            });
          }
        } else {
          const arrValue = typeof arrRow[value] === 'undefined' ? '' : `"${arrRow[value]}"`;
          row += `${arrValue},`;
        }
      });
    row.slice(0, row.length - 1);
    csv += `${row}\r\n`;
  }

  if (csv === '') {
    return;
  }

  // const uri = `data:application/csv;charset=utf-8,${escape(csv)}`;
  const uri = new Blob([csv], { type: 'text/csv' });
  const link = document.createElement('a');
  const csvUrl = URL.createObjectURL(uri);
  // link.href = uri;
  link.href = csvUrl;
  link.style = 'visibility:hidden';
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  
export default csvConverter;



// WEBPACK FOOTER //
// ./src/utils/SavedDrivesCSV.js